import React, { useState } from 'react';
import { Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import Adoption from './Adoption';
import Findings from './Findings';
import Actionables from './Actionables';
import EscalationAlerts from './EscalationAlerts';

// **Deprecated as the canonical surface.** Adoption / Findings / Actionables
// were lifted to top-level store-dashboard tabs (indices 14/15/16) in the
// 2026-06 restructure, and the AI chat button moved to the dashboard
// chrome (top-right, always visible). This wrapper is kept for back-compat
// with any deep links pointing at tab=13 — it renders the same three
// subtabs inline but doesn't host the AI chat anymore (org-level chat
// lives in the dashboard above).
const SUBTABS = [
    { key: 'adoption', label: 'Adoption', Component: Adoption },
    { key: 'findings', label: 'Findings', Component: Findings },
    { key: 'actionables', label: 'Tasks', Component: Actionables },
];

const ClientHealthTab = ({ store_id, store_info, user_details, set_page_loader }) => {
    const [sub, set_sub] = useState('adoption');
    const Active = (SUBTABS.find((t) => t.key === sub) || SUBTABS[0]).Component;

    if (!store_id) {
        return (
            <div style={{ padding: 24, color: '#888' }}>
                Loading client…
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, position: 'relative' }}>
            <Card>
                <CardBody style={{ padding: 8 }}>
                    <Nav pills style={{ gap: 4 }}>
                        {SUBTABS.map((t) => (
                            <NavItem key={t.key}>
                                <NavLink
                                    href='#'
                                    active={sub === t.key}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        set_sub(t.key);
                                    }}
                                >
                                    {t.label}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </CardBody>
            </Card>
            {/* Escalation alerts for this client (cs-analysis /api/v1/alerts):
                compact, expands only when something fired; reps label each
                alert ✓ / ✗ to tune the judge. */}
            <Card>
                <CardBody style={{ padding: '6px 12px' }}>
                    <EscalationAlerts store_id={store_id} />
                </CardBody>
            </Card>
            <Active
                store_id={store_id}
                store_info={store_info}
                user_details={user_details}
                set_page_loader={set_page_loader}
            />
        </div>
    );
};

export default ClientHealthTab;
